import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetWards(args: Parameters<typeof queries.locations.listWards>[0] = {}) {
  const query = queries.locations.listWards({...args, filters: {status: ['active'] as const, ...args.filters}})
  const [wards, meta] = useQuery(query)

  return {query, meta, wards}
}
